import React from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import { CustomerFeedback } from "./Components/Feedback";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/feedback/:hotelId" element={<CustomerFeedback />} />
      </Routes>
    </div>
  );
}

export default App;
